export default __webpack_public_path__ + "static/media/Lokesh.0699f1a7.jpg";